import { defineMessages } from 'react-intl';

export const en_us = defineMessages({
  cta: {
    id: 'pib_header_cta_en',
  },
  text: {
    id: 'pib_header_text_en',
  },
  title: {
    id: 'pib_header_title_en',
  },
  topic: {
    id: 'pib_header_topic_en',
  },
});

export const es = defineMessages({
  cta: {
    id: 'pib_header_cta_es',
  },
  text: {
    id: 'pib_header_text_es',
  },
  title: {
    id: 'pib_header_title_es',
  },
  topic: {
    id: 'pib_header_topic_es',
  },
});
